export default {
  LOGIN_USER: 'LOGIN_USER',
  LOGIN_ERROR: 'LOGIN_ERROR',
  LOGOUT_USER: 'LOGOUT_USER',
};



// WEBPACK FOOTER //
// ./modules/account/constants/AuthConstants.js